/**
 * Returns a function that listens to form submission events on a pagination
 * form and calls pagination handlers accordingly
 * @param {Object} funcs
 * @param {function} funcs.handlePrevButton
 * @param {function} funcs.handleNextButton
 * @param {(input: number) => void} funcs.handleInput
 * @param {function?} funcs.then - Optional: execute after any action
 * @returns {(ev: SubmitEvent) => void}
 */
export const handlePagination = ({
    handlePrevButton, handleNextButton, handleInput, then
}) => (ev) => {
    ev.preventDefault();
    switch (ev.submitter.name) {
    case 'prev': {
        handlePrevButton();
        break;
    }
    case 'next': {
        handleNextButton();
        break;
    }
    case 'input-submitter': {
        const input = new FormData(ev.currentTarget).get('input');
        handleInput(Number(input));
        break;
    }
    default: {
        // do nothing
    }
    }
    then?.(); // eslint-disable-line no-unused-expressions
};

/**
 * @param {Element} formEl
 * @param {{ currentPageNum: number, pageCount: number }} options
 */
export const updatePagination = (formEl, { currentPageNum, pageCount }) => {
    const prevButton = formEl.querySelector('[name="prev"]');
    const nextButton = formEl.querySelector('[name="next"]');
    const input = formEl.querySelector('[name="input"]');
    const count = formEl.querySelector('[data-name="page-count"]');

    prevButton.disabled = currentPageNum <= 1;
    nextButton.disabled = currentPageNum >= pageCount;
    input.value = currentPageNum;
    input.max = pageCount;
    count.textContent = pageCount;
};
